import React, { FC, memo, Fragment } from 'react'
import IconStarFilled from '@ucheba/ui/icons/icon__star-filled.svg'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { p11n } from '@ucheba/utils/helpers/string'
import { Banner } from '../../Banner/desktop'
import { Header, InstitutionRate, List } from '../base/styled'
import { IUsersCommunicationProps, TReducedDataList } from '../types'
import { textContent } from '../constants'
import { reduceDataList, useUsersCommunication } from '../bll'
import CommunicationForm from './CommunicationForm'
import Item from './Item'
import ResponsesList from './ResponsesList'

const UsersCommunication: FC<IUsersCommunicationProps> = (props) => {
  const {
    items,
    params,
    total,
    institutionRate,
    type = 'questions',
    rootId,
    rootType,
    limit,
    offset,
    onAfterSubmit,
  } = props
  const { titleForms, createButtonText } = textContent[type]

  const reducedDataList: TReducedDataList = reduceDataList(items)

  const {
    onAnswerClick,
    onOpenCommunicationForm,
    isDialogOpen,
    onDialogClose,
    formType,
    parentId,
    showBanner,
  } = useUsersCommunication(props)

  if (reducedDataList.length === 0) {
    return null
  }

  return (
    <>
      <Grid nowrap justifyContent='space-between'>
        <GridCol width='auto'>
          <Header>
            <Heading
              as='h1'
              h2={`${total} ${p11n(total, titleForms[0], titleForms[1], titleForms[2])}`}
              spacing='null'
            />

            {!!institutionRate && (
              <InstitutionRate>
                <IconStarFilled />

                <Text fontWeight='extrabold' fontSize='h2' lineHeight='h2' color='orange'>
                  {institutionRate}
                </Text>
              </InstitutionRate>
            )}
          </Header>
        </GridCol>

        <GridCol width='auto'>
          <Button color='blue' onClick={onOpenCommunicationForm}>
            {createButtonText}
          </Button>
        </GridCol>
      </Grid>

      <Spacing spacing='medium' />

      <List>
        {reducedDataList.map(({ root, responses }, index) => {
          const isDivider = true

          return (
            <Fragment key={root.id}>
              <Item
                isDivider={isDivider}
                key={root.id}
                type={type}
                id={root.id}
                rate={root.rate}
                date={root.dateCreated}
                text={root.text}
                faculty={root.faculty}
                program={root.program}
                owner={root.owner}
                responseFor={root.responseFor}
                voteStats={root.voteStats}
                onAnswerClick={() => onAnswerClick(root.id)}
                itemsLength={total}
                rootId={rootId}
                rootType={rootType}
                limit={limit}
                offset={offset}
              />

              {responses?.length > 0 && (
                <>
                  <Spacing spacing='xlarge' />

                  <ResponsesList
                    onAnswerClick={onAnswerClick}
                    type={type}
                    parentId={String(root.id)}
                    responses={responses}
                    itemsLength={items.length}
                    rootId={rootId}
                    rootType={rootType}
                    limit={limit}
                    offset={offset}
                  />
                </>
              )}

              {showBanner(index) && (
                <li>
                  <Banner
                    id={2}
                    extraParams={params}
                    spacing={{
                      bottom: 'xlarge',
                      top: 'xlarge',
                    }}
                  />
                </li>
              )}
            </Fragment>
          )
        })}
      </List>

      <CommunicationForm
        formType={formType}
        isOpen={isDialogOpen}
        parentId={parentId}
        onClose={onDialogClose}
        list={items}
        rootId={rootId}
        type={rootType}
        limit={limit}
        offset={offset}
        onAfterSubmit={onAfterSubmit}
      />
    </>
  )
}

export default memo(UsersCommunication)
